import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const TITLE = 'title'
const SORT_ORDER = 'sort_order'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [SORT_ORDER]: {
      label: `${t('common.sort-order')}`,
      name: SORT_ORDER,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TITLE]: '',
  [SORT_ORDER]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [TITLE]: yup.string().required(`${t('errors.required-error-message')}`),
    [SORT_ORDER]: yup.number().required(`${t('errors.required-error-message')}`),
  })

export default formModel
